
function filterToggle()
{

  const openFilterButtons = document.querySelectorAll('.openfilter');
  const elementToToggle = document.getElementById("filtertoggle");
  const topButton = document.querySelector('#openfilter1');


   if (window.innerWidth <= 760) {
    document.querySelector('#openfilter2').style.display = "flex";
  }

  // Set a fixed max-height when the element is hidden
  elementToToggle.style.maxHeight = "0";
  openFilterButtons.forEach(function(openFilterButton) {
    openFilterButton.addEventListener('click', function(event) {
      event.preventDefault();
      
      if (elementToToggle.style.display === "none") {
        // If the element is hidden, show it with a sliding effect
        elementToToggle.style.display = "block"; // or "inline-block" based on your layout
        elementToToggle.style.maxHeight = elementToToggle.scrollHeight + "px";
        document.querySelector('#openfilter1').innerText = "Close";
        document.querySelector('#openfilter1').classList.remove("closed");
        document.querySelector('#openfilter1').classList.add("open");

        if (window.innerWidth <= 760) {
          document.querySelector('#openfilter1').style.display = "none";
        }
      } else {
          // If the element is visible, hide it
          elementToToggle.style.maxHeight = "0";
         // elementToToggle.style.display = "none";
          document.querySelector('#openfilter1').innerText = "Filters";
          document.querySelector('#openfilter1').classList.remove("open");
          document.querySelector('#openfilter1').classList.add("closed");

          if (window.innerWidth <= 760) {
            document.querySelector('#openfilter1').style.display = "block";
          }

          // After the closing animation completes, hide the element
          elementToToggle.addEventListener("transitionend", function() {
            if (elementToToggle.style.maxHeight === "0px") {
              elementToToggle.style.display = "none";
            }
          });
      } // end if else
    });
  });
}

/* 
  SEARCH INPUT
*/

// function updateSearchListing(searchText) {
//   const itemList = Array.from(document.getElementById("caselisting").getElementsByClassName("caselisting-item"));
//   itemList.forEach((li) => {
//     const title = li.getAttribute("data-title").toLowerCase();

//     if (title.includes(searchText)) {
//         li.style.display = "block"; // Show the matching items
//     } else {
//         li.style.display = "none"; // Hide the non-matching items
//     }
//   });
// }

function searchInput()
{
  const myInput = document.getElementById("search");
  myInput.addEventListener("input", function() {
      const inputValue = myInput.value;

      // Check if the input length is at least 3 characters
      if (inputValue.length >= 3) {
        //updateSearchListing(inputValue);
        // Create an array to hold all selected values
        const selectedItems = [];

        // Get selected values for each group and add them to the selectedItems array
        selectedItems.push(...getSelectedValues("solutions-checkbox"));
        selectedItems.push(...getSelectedValues("industries-checkbox"));
        selectedItems.push(...getSelectedValues("technologies-checkbox"));

        // Call your function and pass the combined selectedItems array
        processSelectedItems(selectedItems);
      } 

      if (inputValue.length == 0) {
        const itemList = Array.from(document.getElementById("caselisting").getElementsByClassName("caselisting-item"));
        itemList.forEach((li) => {
            li.style.display = "block"; 
        });
      }
  });
}

/* 
  APPLY FILTER
*/

function getSelectedValues(groupName) {
  const checkboxes = document.querySelectorAll(`input[name=${groupName}]:checked`);
  return Array.from(checkboxes, checkbox => checkbox.value);
}

function processSelectedItems(selectedItems) {

  const searchText = document.getElementById("search").value.toLowerCase();
  const itemList = Array.from(document.getElementById("caselisting").getElementsByClassName("caselisting-item"));
  
  itemList.forEach((li) => {
      // Check if any of the IDs in the data-id attribute match the selected items or search input
      if (selectedItems.length > 0) {
        const dataId = li.getAttribute("data-tags");
        const idArray = dataId.split(',').map(id => id.trim());
        const match = idArray.some(id => selectedItems.includes(id) || id === searchText);
        if (match) {
            li.style.display = "block"; // Show the matching items
        } else {
            li.style.display = "none"; // Hide the non-matching items
        }
      } else {
        const title = li.getAttribute("data-title").toLowerCase();
        if (title.includes(searchText)) {
            li.style.display = "block"; // Show the matching items
        } else {
            li.style.display = "none"; // Hide the non-matching items
        }
      }
  });

}

function applySelections()
{
  document.getElementById("applyButton").addEventListener("click", function() {
    // Create an array to hold all selected values
    const selectedItems = [];

    // Get selected values for each group and add them to the selectedItems array
    selectedItems.push(...getSelectedValues("solutions-checkbox"));
    selectedItems.push(...getSelectedValues("industries-checkbox"));
    selectedItems.push(...getSelectedValues("technologies-checkbox"));

    // Call your function and pass the combined selectedItems array
    processSelectedItems(selectedItems);
  });
}

/* CLEAR BUTTON */

function clearFilters()
{
  // Clear the search input
  document.getElementById("search").value = "";

  // Clear the selected checkboxes (assumes checkboxes have unique IDs)
  clearSelectedCheckboxes("solutions-checkbox");
  clearSelectedCheckboxes("industries-checkbox");
  clearSelectedCheckboxes("technologies-checkbox");

  // Reset the list of <li> elements to their initial state
  const itemList = Array.from(document.getElementById("caselisting").getElementsByClassName("caselisting-item"));
  itemList.forEach((li) => {
      li.style.display = "block"; // Show all items
  });
}

function clearSelectedCheckboxes(groupName)
{
  const checkboxes = document.querySelectorAll(`input[name=${groupName}`);
  checkboxes.forEach(checkbox => {
      checkbox.checked = false;
  });
}

document.addEventListener('DOMContentLoaded', function() {

  const caseDiv = document.querySelector(".case-div");

  if (caseDiv) {
    filterToggle();

    searchInput();

    applySelections();

    document.getElementById("clearButton").addEventListener("click", clearFilters);
  }

});